import { useEffect } from "react";
import { usePurchasedCompany } from "./usePurchasedCompany";

/* Resolves one purchase's business name and hands it up. */
export const CompanyNameProbe = ({ row, token, id, onResolve }) => {
  const { displayName } = usePurchasedCompany(row, token);

  useEffect(() => {
    if (displayName) onResolve(id, displayName);
  }, [displayName, id, onResolve]);

  return null;
};

export default CompanyNameProbe;
